import React, { useCallback, forwardRef, useMemo } from 'react';
import CheckCircleOutlined from '@ant-design/icons/CheckCircleOutlined';
import SyncOutlined from '@ant-design/icons/SyncOutlined';
import ExclamationCircleOutlined from '@ant-design/icons/ExclamationCircleOutlined';
import DragCardList from '../DragCardList/DragCardList';
import './MailCardList.scss';
import { getMailKey, systemIsWindow } from '../../../../util';
import { getIn18Text } from 'api';
const getListNoMoreRender = () => (React.createElement("div", { className: "mail-list-topline" },
    React.createElement("span", null, getIn18Text('DAODILA'))));
const getListLoading = state => {
    if (state === 'loading') {
        return (React.createElement("div", null,
            React.createElement(SyncOutlined, { spin: true })));
    }
    if (state === 'success') {
        return (React.createElement("div", null,
            React.createElement(CheckCircleOutlined, { twoToneColor: "#52c41a" })));
    }
    if (state === 'failed') {
        return (React.createElement("div", null,
            React.createElement(ExclamationCircleOutlined, null)));
    }
    return (React.createElement("div", null,
        React.createElement(SyncOutlined, null)));
};
const getListLoadMoreLoading = () => (React.createElement("div", null,
    React.createElement(SyncOutlined, { spin: true })));
const DragFlagId = 'drag-active-icon';
const DragFlag = (React.createElement("div", { className: "drag-active-icon-wrap", id: DragFlagId },
    React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M1.875 4.125C1.875 3.57272 2.32272 3.125 2.875 3.125H17.125C17.6773 3.125 18.125 3.57272 18.125 4.125V15.875C18.125 16.4273 17.6773 16.875 17.125 16.875H2.875C2.32272 16.875 1.875 16.4273 1.875 15.875V4.125Z", stroke: "#386EE7", strokeWidth: "1.5", strokeLinecap: "round" }),
        React.createElement("path", { d: "M2.5 3.75L9.55624 8.45416C9.82496 8.63331 10.175 8.63331 10.4438 8.45416L17.5 3.75", stroke: "#386EE7", strokeWidth: "1.5" }))));
const defaultOnMailDrag = (event, domId) => {
    const element = document.getElementById(domId);
    if (element) {
        event.dataTransfer.setDragImage(element, -10, -10);
    }
};
const MailCardList = (props, ref) => {
    const { onDragStart, onDragEnd, activeId = [], className } = props;
    const componentId = useMemo(() => {
        return new Date().getTime() + '';
    }, []);
    const dragFlagMultId = useMemo(() => `drag-active-icon-mult${componentId}`, [componentId]);
    const handleMailDragStart = useCallback((event, data, index) => {
        defaultOnMailDrag(event, activeId && activeId.length > 1 ? dragFlagMultId : DragFlagId);
        onDragStart && onDragStart(event, data, index);
    }, [activeId, onDragStart]);
    const handleMailDragEnd = useCallback((event, data, index) => {
        onDragEnd && onDragEnd(event, data, index);
    }, [onDragEnd]);
    const DragFlagMult = useMemo(() => (React.createElement("div", { className: "drag-active-icon-wrap", id: dragFlagMultId },
        React.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M1.875 4.125C1.875 3.57272 2.32272 3.125 2.875 3.125H17.125C17.6773 3.125 18.125 3.57272 18.125 4.125V15.875C18.125 16.4273 17.6773 16.875 17.125 16.875H2.875C2.32272 16.875 1.875 16.4273 1.875 15.875V4.125Z", stroke: "#386EE7", strokeWidth: "1.5", strokeLinecap: "round" }),
            React.createElement("path", { d: "M2.5 3.75L9.55624 8.45416C9.82496 8.63331 10.175 8.63331 10.4438 8.45416L17.5 3.75", stroke: "#386EE7", strokeWidth: "1.5" })),
        React.createElement("div", { hidden: activeId && activeId.length <= 1, className: "drag-mail-number" }, activeId === null || activeId === void 0 ? void 0 : activeId.length))), [componentId, activeId]);
    return (React.createElement(React.Fragment, null,
        React.createElement(DragCardList, Object.assign({ ref: ref, noMoreRender: getListNoMoreRender }, props, { pullRefreshRender: getListLoading, loadMoreLoadingRender: getListLoadMoreLoading, className: `${systemIsWindow() ? 'u-vlist-win' : 'u-vlist'} ${className}`, initLoadMore: false, batchSize: 100, threshold: 500, onDragStart: handleMailDragStart, onDragEnd: handleMailDragEnd, getUniqKey: getMailKey })),
        React.createElement("div", { style: { position: 'absolute', zIndex: -99999, bottom: 0, left: 0 } },
            DragFlag,
            DragFlagMult)));
};
export default forwardRef(MailCardList);
